import { queryClient } from '@/api/queryClient.ts'

export type AlertHistoryType = 'sos' | 'fall'

const HISTORY_QUERY_KEYS: Record<AlertHistoryType, readonly string[]> = {
    sos: ['notification', 'apiGetNotificationSos'],
    fall: ['notification', 'apiGetNotificationFallDetection']
}

/**
 * 처리 직후 이전 알림 목록이 다시 노출되지 않도록 목록 캐시를 초기화한다.
 * 활성 목록은 즉시 다시 조회하고, 비활성 목록은 다음 진입 시 빈 상태에서 조회한다.
 */
export const resetAlertHistoryCache = async (type: AlertHistoryType) => {
    await queryClient.resetQueries({
        queryKey: HISTORY_QUERY_KEYS[type],
        exact: false
    })
}
